const initialState = {
  deviceCount: { loading: false, error: null, data: null },
  devicesAcrossIndia: { loading: false, error: null, data: null },
  appVersion: { loading: false, error: null, data: null },
  stbCountTrend: { loading: false, error: null, data: null },
  appVersionTrend: { loading: false, error: null, data: null },
  manufacturerBreakdown: { loading: false, error: null, data: null },
};

export const LIT_DEVICE_COUNT_REQUEST = "LIT_DEVICE_COUNT_REQUEST";
export const LIT_DEVICE_COUNT_SUCCESS = "LIT_DEVICE_COUNT_SUCCESS";
export const LIT_DEVICE_COUNT_FAILURE = "LIT_DEVICE_COUNT_FAILURE";

export const LIT_DEVICES_INDIA_REQUEST = "LIT_DEVICES_INDIA_REQUEST";
export const LIT_DEVICES_INDIA_SUCCESS = "LIT_DEVICES_INDIA_SUCCESS";
export const LIT_DEVICES_INDIA_FAILURE = "LIT_DEVICES_INDIA_FAILURE";

export const LIT_APP_VERSION_REQUEST = "LIT_APP_VERSION_REQUEST";
export const LIT_APP_VERSION_SUCCESS = "LIT_APP_VERSION_SUCCESS";
export const LIT_APP_VERSION_FAILURE = "LIT_APP_VERSION_FAILURE";

export const LIT_STB_COUNT_TREND_REQUEST = "LIT_STB_COUNT_TREND_REQUEST";
export const LIT_STB_COUNT_TREND_SUCCESS = "LIT_STB_COUNT_TREND_SUCCESS";
export const LIT_STB_COUNT_TREND_FAILURE = "LIT_STB_COUNT_TREND_FAILURE";

export const LIT_APP_VERSION_TREND_REQUEST = "LIT_APP_VERSION_TREND_REQUEST";
export const LIT_APP_VERSION_TREND_SUCCESS = "LIT_APP_VERSION_TREND_SUCCESS";
export const LIT_APP_VERSION_TREND_FAILURE = "LIT_APP_VERSION_TREND_FAILURE";

export const LIT_MANUFACTURER_BREAKDOWN_REQUEST = "LIT_MANUFACTURER_BREAKDOWN_REQUEST";
export const LIT_MANUFACTURER_BREAKDOWN_SUCCESS = "LIT_MANUFACTURER_BREAKDOWN_SUCCESS";
export const LIT_MANUFACTURER_BREAKDOWN_FAILURE = "LIT_MANUFACTURER_BREAKDOWN_FAILURE";

const litDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIT_DEVICE_COUNT_REQUEST:
      return { ...state, deviceCount: { loading: true, error: null, data: null } };
    case LIT_DEVICE_COUNT_SUCCESS:
      return { ...state, deviceCount: { loading: false, error: null, data: action.payload } };
    case LIT_DEVICE_COUNT_FAILURE:
      return { ...state, deviceCount: { loading: false, error: action.payload, data: null } };

    case LIT_DEVICES_INDIA_REQUEST:
      return { ...state, devicesAcrossIndia: { loading: true, error: null, data: null } };
    case LIT_DEVICES_INDIA_SUCCESS:
      return { ...state, devicesAcrossIndia: { loading: false, error: null, data: action.payload } };
    case LIT_DEVICES_INDIA_FAILURE:
      return { ...state, devicesAcrossIndia: { loading: false, error: action.payload, data: null } };

    case LIT_APP_VERSION_REQUEST:
      return { ...state, appVersion: { loading: true, error: null, data: null } };
    case LIT_APP_VERSION_SUCCESS:
      return { ...state, appVersion: { loading: false, error: null, data: action.payload } };
    case LIT_APP_VERSION_FAILURE:
      return { ...state, appVersion: { loading: false, error: action.payload, data: null } };

    case LIT_STB_COUNT_TREND_REQUEST:
      return { ...state, stbCountTrend: { loading: true, error: null, data: null } };
    case LIT_STB_COUNT_TREND_SUCCESS:
      return { ...state, stbCountTrend: { loading: false, error: null, data: action.payload } };
    case LIT_STB_COUNT_TREND_FAILURE:
      return { ...state, stbCountTrend: { loading: false, error: action.payload, data: null } };

    case LIT_APP_VERSION_TREND_REQUEST:
      return { ...state, appVersionTrend: { loading: true, error: null, data: null } };
    case LIT_APP_VERSION_TREND_SUCCESS:
      return { ...state, appVersionTrend: { loading: false, error: null, data: action.payload } };
    case LIT_APP_VERSION_TREND_FAILURE:
      return { ...state, appVersionTrend: { loading: false, error: action.payload, data: null } };

    case LIT_MANUFACTURER_BREAKDOWN_REQUEST:
      return { ...state, manufacturerBreakdown: { loading: true, error: null, data: null } };
    case LIT_MANUFACTURER_BREAKDOWN_SUCCESS:
      return { ...state, manufacturerBreakdown: { loading: false, error: null, data: action.payload } };
    case LIT_MANUFACTURER_BREAKDOWN_FAILURE:
      return { ...state, manufacturerBreakdown: { loading: false, error: action.payload, data: null } };

    default:
      return state;
  }
};

export default litDashboardReducer;
